import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServicesRoutingModule } from './services-routing.module';
import { ServicesPageComponent } from './services-page/services-page.component';
import { AccordionComponent } from '../accordion/accordion.component';
import { SharedContactFormModule } from '../shared/sharedContactForm.module';
import { SharedAccordionModule } from '../shared/shared-accordion.module';


@NgModule({
  declarations: [
    ServicesPageComponent
  ],
  imports: [
    CommonModule,
    ServicesRoutingModule,
    SharedContactFormModule,
    SharedAccordionModule,
  ]
})
export class ServicesModule { }
